import React from 'react';
const rows = [['Cleaning the same carb a third time', 'The Carb Decision Gate: adjust, clean, rebuild or replace'], ['Parts cannon: carb, pump, plugs, lines', 'Cheapest test first, gate by gate'], ['Diagnostic time given away', 'A diagnostic fee explained on the repair order'], ['“Where is my mower?” calls all day', 'Ready-for-pickup messages and the Pickup-Ready Workflow'], ['The same machine back next month', 'Customer Care sheets handed over at pickup']];
export function CostOfInaction() {
  return <section className="w-full bg-pine" data-id="element-63" data-mp="38wajtvlleziv">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" data-id="element-64" data-mp="38v8wosraymks">
        <h2 className="text-center font-display text-[32px] uppercase leading-tight text-paper sm:text-5xl" data-id="element-65" data-mp="3dovbaqh110j8">
          What another season of guessing costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-paper/15" data-id="element-66" data-mp="3nnasa0mcatf0">
          <div className="grid grid-cols-2 text-center" data-id="element-67" data-mp="3slcj57q0bx11">
            <div className="border-r border-paper/15 bg-signal px-3 py-3 font-display text-lg uppercase text-white sm:text-xl" data-id="element-68" data-mp="3sluhqb056nc4">
              Guessing
            </div>
            <div className="bg-forest px-3 py-3 font-display text-lg uppercase text-white sm:text-xl" data-id="element-69" data-mp="39gbvkny6t86i">
              The 4 Gates
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-paper/15 text-[13px] leading-snug sm:text-sm" data-id="element-70" data-mp="30i04kktes8dj">
              <div className="border-r border-paper/15 px-3.5 py-3.5 text-paper/60 line-through decoration-signal/60" data-id="element-71" data-mp="3s84m8bpsahb2">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-semibold text-paper" data-id="element-72" data-mp="3nfbj1s9yrh13">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}